var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plug"},[_c('div',{staticClass:"plug__wrapper"},[_c('div',{staticClass:"plug__icon-wrapper"},[_c('icon',{staticClass:"plug__icon",attrs:{"icon":_vm.icon,"width":_vm.width,"height":_vm.height,"color":_vm.color}})],1),_c('div',{staticClass:"plug__text"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }